<!-- ================= CHAT QUESTION ================= -->
@if (data?.bot_type === 'bot') {
  @if (data?.question) {
    <div class="chat-list-row question-row" id="question{{ data?.sequence_id }}">
      <div class="question-card" [class.loading]="showPaginateSpinner">
        <div class="question-icon">
          @if (data?.query_type === 'generic') {
            <i class="pi pi-globe"></i>
          } @else if (data?.query_type === 'private') {
            <i class="pi pi-file"></i>
          } @else {
            <i class="pi pi-comment"></i>
          }
        </div>

        <div class="question-body">
          <!-- <div class="message-label">Your question</div> -->

          <div class="question-text">
            @if (!data.search) {
              {{ formatQuestion(data?.question) | capitalize }}
            } @else {
              <ngx-typed-writer
                [strings]="animateQuestion(data?.question)"
                [isHTML]="true"
                [smartBackspace]="false"
                [backSpeed]="20"
                [typeSpeed]="50"
                [autoStart]="true"
                [loop]="false"
                [shuffle]="false">
              </ngx-typed-writer>
            }
          </div>

          @if (showPaginateSpinner) {
            <div class="typing-indicator">
              <span></span><span></span><span></span>
              <small>Generating answer...</small>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- ================= SINGLE ANSWER ================= -->
  @if (!showPaginateSpinner && !multipleAnswers && data.bot_answer) {
    <div class="chat-list-row answer-row">
      <article class="answer-card">
        <header class="answer-header">
          <div class="assistant-identity">
            <!-- <div class="assistant-avatar">
              <i class="pi pi-sparkles"></i>
            </div>

            <div>
              <div class="assistant-name">AI Assistant</div>
              <div class="assistant-subtitle">Generated response</div>
            </div> -->
          </div>

          <div class="answer-actions">
            <button type="button" class="icon-action"
              (click)="openEditAIModal(data)"
              title="Edit answer" aria-label="Edit answer">
              <i class="pi pi-pen-to-square"></i>
            </button>

            <span class="icon-action audio-action" title="Play audio">
              <app-toggle-icon
                [icons]="volumeicons"
                [defaultState]="'off'"
                (iconState)="speakText($event, data.bot_answer)">
              </app-toggle-icon>
            </span>

            <!-- <button type="button" class="icon-action"
              (click)="generateAudio()"
              title="Generate audio" aria-label="Generate audio">
              <i class="pi pi-volume-up"></i>
            </button> -->

            <button type="button" class="icon-action"
              (click)="PingedChat(index)"
              [class.is-pinned]="isPin"
              title="Pin answer" aria-label="Pin answer">
              <i class="pi pi-thumbtack"></i>
            </button>

            <button type="button" class="icon-action"
              (click)="openDialog()"
              title="Generate document" aria-label="Generate document">
              <i class="pi pi-file-export"></i>
            </button>

            <button type="button" class="icon-action"
              (click)="copiedText(index)"
              title="Copy answer" aria-label="Copy answer">
              <i class="pi pi-copy"></i>
            </button>
          </div>
        </header>

        <div class="answer-content"
          [innerHTML]="changeNewLine(data?.bot_answer)">
        </div>

        @if (data?.source_doc) {
          <div class="source-document">
            <i class="pi pi-file"></i>
            <span>Source:</span>
            <span>{{ data.source_doc }}</span>
          </div>
        }

        @if (!searchView && data.source_paragraphs?.length) {
          <section class="source-section">
            <button type="button" class="source-toggle"
              (click)="toggleTextView()">
              <i [class]="showTextView ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
              {{ showTextView ? 'Hide source excerpts' : 'View source excerpts' }}
            </button>

            @if (showTextView) {
              <div class="source-excerpt"
                [innerHTML]="cleanedSourceParagraphs">
              </div>
            }
          </section>
        }

        <!-- ================= FEEDBACK ================= -->
        <footer class="feedback-section">
          <span class="feedback-label">Was this answer helpful?</span>

          <div class="feedback-actions">
            <button type="button" class="feedback-button"
              [class.selected]="isActiveFeedback"
              (click)="showFeedbackform()"
              aria-label="Helpful answer">
              <i class="pi pi-thumbs-up"></i>
              <span>Helpful</span>
            </button>

            <button type="button" class="feedback-button"
              [class.selected]="isInActiveFeedback"
              (click)="showInActiveFeedback()"
              aria-label="Not helpful">
              <i class="pi pi-thumbs-down"></i>
              <span>Not helpful</span>
            </button>
          </div>

          @if (isActiveFeedback || isInActiveFeedback) {
            <div class="feedback-form">
              <form [formGroup]="commentForm">
                <label for="answer-feedback">Additional comments</label>
                <textarea id="answer-feedback"
                  formControlName="comment"
                  rows="3"
                  (keyup)="onKeypressEvent($event)"
                  placeholder="Tell us how we can improve this answer...">
                </textarea>

                <div class="feedback-form-actions">
                  <button type="button" class="btn-cancel"
                    (click)="cancelComment(data)">
                    Cancel
                  </button>

                  <button type="button" class="btn-submit"
                    [disabled]="commentForm.invalid || showSpinner"
                    (click)="saveComment(data, isActiveFeedback ? 'No' : 'Yes')">
                    @if (showSpinner) {
                      <i class="pi pi-spin pi-spinner"></i>
                      Submitting...
                    } @else {
                      Submit feedback
                    }
                  </button>
                </div>
              </form>
            </div>
          }
        </footer>

        <div class="message-timestamp">
          <i class="pi pi-clock"></i>
          {{ data.createdAt | date : 'MMM d, y, h:mm a' }}
        </div>
      </article>
    </div>
  }

  <!-- ================= MULTIPLE ANSWERS ================= -->
  @if (multipleAnswers) {
    @for (answerItem of multipleAnswersData; track answerItem; let answerIndex = $index) {
      <div class="chat-list-row answer-row">
        <article class="answer-card">
          <header class="answer-header">
            <div class="assistant-identity">
              <div class="assistant-avatar">
                <i class="pi pi-sparkles"></i>
              </div>
              <div>
                <div class="assistant-name">AI Assistant</div>
                <div class="assistant-subtitle">
                  Response {{ answerIndex + 1 }}
                </div>
              </div>
            </div>

            <div class="answer-actions">
              <button type="button" class="icon-action"
                (click)="openEditAIModal({
                  bot_answer: answerItem.answer,
                  history_id: data.history_id
                }, answerIndex)"
                title="Edit answer">
                <i class="pi pi-pen-to-square"></i>
              </button>

              <span class="icon-action audio-action" title="Play audio">
                <app-toggle-icon
                  [icons]="volumeicons"
                  [defaultState]="'off'"
                  (iconState)="speakText($event, answerItem.answer)">
                </app-toggle-icon>
              </span>

              <button type="button" class="icon-action"
                (click)="generateAudio()" title="Generate audio">
                <i class="pi pi-volume-up"></i>
              </button>

              <button type="button" class="icon-action"
                (click)="PingedChat(answerIndex)"
                [class.is-pinned]="isPin" title="Pin answer">
                <i class="pi pi-thumbtack"></i>
              </button>

              <button type="button" class="icon-action"
                (click)="openDialog()" title="Generate document">
                <i class="pi pi-file-export"></i>
              </button>

              <button type="button" class="icon-action"
                (click)="copiedText(answerIndex)" title="Copy answer">
                <i class="pi pi-copy"></i>
              </button>
            </div>
          </header>

          @if (answerItem) {
            <div class="answer-question">
              <span>Question</span>
              <p>{{ answerItem.question }}</p>
            </div>

            <div class="answer-content"
              [innerHTML]="mode === 'answer'
                ? (answerItem.answer ? changeNewLine(answerItem.answer) : '')
                : (answerItem.source_paragraphs
                  ? changeNewLine(getSearch(answerItem.source_paragraphs))
                  : '')">
            </div>

            @if (answerItem.source_paragraphs?.length) {
              <div class="source-document">
                <i class="pi pi-file"></i>
                <span>Source:</span>
                <span>{{ fileSources_para(answerItem.source_paragraphs) }}</span>
              </div>
            }

            @if (!searchView && answerItem.source_paragraphs?.length) {
              <section class="source-section">
                <button type="button" class="source-toggle"
                  (click)="toggleTextView()">
                  <i [class]="showTextView ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                  {{ showTextView ? 'Hide source excerpts' : 'View source excerpts' }}
                </button>

                @if (showTextView) {
                  <div class="source-excerpt"
                    [innerHTML]="fileSources_para_text(answerItem.source_paragraphs)">
                  </div>
                }
              </section>
            }
          }

          <footer class="feedback-section">
            <span class="feedback-label">Was this answer helpful?</span>

            <div class="feedback-actions">
              <button type="button" class="feedback-button"
                [class.selected]="isAnswerItemActiveFeedback(answerIndex)"
                (click)="showFeedbackform(answerIndex)">
                <i class="pi pi-thumbs-up"></i>
                <span>Helpful</span>
              </button>

              <button type="button" class="feedback-button"
                [class.selected]="isAnswerItemInActiveFeedback(answerIndex)"
                (click)="showInActiveFeedback(answerIndex)">
                <i class="pi pi-thumbs-down"></i>
                <span>Not helpful</span>
              </button>
            </div>

            @if (isAnswerItemActiveFeedback(answerIndex) ||
                 isAnswerItemInActiveFeedback(answerIndex)) {
              <div class="feedback-form">
                <form [formGroup]="commentForm">
                  <label [for]="'answer-feedback-' + answerIndex">
                    Additional comments
                  </label>

                  <textarea [id]="'answer-feedback-' + answerIndex"
                    formControlName="comment"
                    rows="3"
                    (keyup)="onKeypressEvent($event)"
                    placeholder="Tell us how we can improve this answer...">
                  </textarea>

                  <div class="feedback-form-actions">
                    <button type="button" class="btn-cancel"
                      (click)="cancelComment(answerItem, answerIndex)">
                      Cancel
                    </button>

                    <button type="button" class="btn-submit"
                      [disabled]="commentForm.invalid"
                      (click)="saveComment(
                        prepareCommentData(answerItem),
                        isAnswerItemActiveFeedback(answerIndex) ? 'No' : 'Yes',
                        answerIndex
                      )">
                      Submit feedback
                    </button>
                  </div>
                </form>
              </div>
            }
          </footer>

          <div class="message-timestamp">
            <i class="pi pi-clock"></i>
            {{ (answerItem.createdAt || data.createdAt) | date : 'MMM d, y, h:mm a' }}
          </div>
        </article>
      </div>
    }
  }
}

@if (showPaginateSpinner) {
  <div class="pagination-loading-space"></div>
}

<!-- ================= EDIT ANSWER MODAL ================= -->
<div class="answer-modal-backdrop"
  [class.visible]="showModal"
  [style.display]="showModal ? 'flex' : 'none'"
  (click)="closeModal()">

  <div class="answer-modal"
    [class.fullscreen]="editorFullView"
    role="dialog"
    aria-modal="true"
    aria-labelledby="edit-answer-title"
    (click)="$event.stopPropagation()">

    <header class="modal-header">
      <div class="modal-heading">
        <div class="modal-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <div>
          <h2 id="edit-answer-title">Edit answer</h2>
          <p>Update, refine, or export your AI response.</p>
        </div>
      </div>

      <div class="modal-header-actions">
        <button type="button" class="icon-action"
          (click)="modalFullScreen()"
          [title]="editorFullView ? 'Exit fullscreen' : 'Fullscreen'">
          <i [class]="editorFullView
            ? 'pi pi-window-minimize'
            : 'pi pi-window-maximize'">
          </i>
        </button>

        <button type="button" class="icon-action"
          (click)="closeModal()" title="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </header>

    <div class="modal-body">
      <div class="editor-container">
        <div id="toolbar_{{ data.history_id }}"></div>
        <div id="editor_{{ data.history_id }}"></div>
      </div>
    </div>

    <footer class="modal-footer">
      <div class="file-name-field">
        <label for="document-file-name">Document name</label>
        <input id="document-file-name"
          type="text"
          [(ngModel)]="documentFileName"
          (input)="ValidatefileName($event)"
          placeholder="Enter document name">

        @if (documentFileNameError) {
          <small class="field-error">{{ documentFileNameError }}</small>
        }
      </div>

      <div class="modal-footer-actions">
        <button type="button" class="btn-cancel"
          (click)="closeModal()">
          Cancel
        </button>

        <button type="button" class="btn-export"
          (click)="saveAsPdf(editBotHistoryId, editAIData)">
          <i class="pi pi-file-pdf"></i>
          Export PDF
        </button>

        <button type="button" class="btn-export"
          (click)="saveAsDoc(editBotHistoryId, editAIData)">
          <i class="pi pi-file-word"></i>
          Export DOCX
        </button>

        <button type="button" class="btn-submit"
          (click)="saveEditAI(editBotHistoryId, editAIData)">
          <i class="pi pi-check"></i>
          Save changes
        </button>
      </div>
    </footer>
  </div>
</div>
